export default {"src":"/_next/static/media/section2-icon3.15dae541.svg","height":115,"width":115,"blurWidth":0,"blurHeight":0};